export default __webpack_public_path__ + "static/r-pitch-scheda-tecnica-0381cbc791d06da74e1b13420e146d77.pdf";